import React from "react";
import { useFullOrderModel, FullOrderEnum } from "../fullOrderModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { fullOrderSDs, fullOrderStatusSDs } from "@/types/FmsDs"

export function BusSearchBox() {
    const {
        searchParam,
        initPgCfg,
        fullOrderStatus,
        resetSearchParam,
        updateSearchParam,
        busSaleLoadData
    } = useFullOrderModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "单位名称",
            fieldName: "customerName",
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "单据编号",
            fieldName: "code",
        }, {
            type: SearchTypeEnum.Select,
            placeholder: "单据类型",
            fieldName: "tradeTypeCode",
            options: [
                {
                    label: '公交销售单',
                    value: 'trade-type.transit-sale'
                },
                {
                    label: '公交销退单',
                    value: 'trade-type.transit-sreturn'
                },
            ]
        }, {
            type: SearchTypeEnum.Input,
            placeholder: "制单员",
            fieldName: "createUser",
        }, {
            type: SearchTypeEnum.Select,
            placeholder: "单据状态",
            fieldName: "status",
            options: fullOrderStatusSDs
        },
    ]

    const searchMoreFields = [
        {
            type: SearchTypeEnum.FullRangePicker,
            fieldName: "",
            placeholder: ["制单日期起始", "制单日期结束"],
            rangePickerFieldName: ["startTime", "endTime"],
            format: "YYYY-MM-DD",
            span: 12,
            xxl: 6,
        },
    ]

    const repairSearchMoreFields = [
        {
            type: SearchTypeEnum.FullRangePicker,
            fieldName: "",
            placeholder: ["制单日期起始", "制单日期结束"],
            rangePickerFieldName: ["createStartTime", "createEndTime"],
            format: "YYYY-MM-DD",
            span: 12,
            xxl: 6,
        },
    ]

    return (
        <YhPageHeader
            title="全量单据列表"
            triggerSearch={true}
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            searchMoreFields={fullOrderStatus === FullOrderEnum.repair ? repairSearchMoreFields : searchMoreFields}
            onChange={updateSearchParam}
            handleSearch={(params) => { busSaleLoadData(initPgCfg, { ...searchParam, ...params }) }}
            handleReset={resetSearchParam}
        />
    );
}